import { StandardConnectingHardwareModel } from '@paragon/contract-library';

export function getConnectingHardwareName(hardware: StandardConnectingHardwareModel) {
  return hardware.replaceAll('_', '-');
}
